import { Divider, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { accessControlSettingsSelector, showBannerSelector } from "../../../../../store/api/admin/selectors";
import { useGetUserBySelfQuery } from "../../../../../store/api/admin/adminApiSlice";
import dayjs from "dayjs";
import { DATEFORMATS } from "../../../../../globals/globals";
import { usernameSelector } from "../../../../../store/api/auth/selectors";
import { GetPasswordExpiryData } from "../../../helpers";
import { useClearFailedLoginMutation } from "../../../../../store/api/admin/adminApiSlice";
import { useEffect } from "react";

export const LoginBanner : React.FC<any> = () => {
    const username = useSelector(usernameSelector);
    const accessControlSettings = useSelector(accessControlSettingsSelector);
    const { data : user } = useGetUserBySelfQuery({ name: username });
    const lastLoginTime = dayjs(user?.lastLoggedInTime !== undefined ? new Date(user.lastLoggedInTime) : new Date(Date.now())).format(DATEFORMATS.TSN);
    const { showPasswordExpiryMessage, expiryDays } = GetPasswordExpiryData(user, accessControlSettings);

    const [clearFailedLogin] = useClearFailedLoginMutation();

    const failedLoginCount = user?.failedLoginCount ?? 0;
    const failedLoginDateTime = user?.failedLoginDateTime;
    const hasFailedLogins = failedLoginCount > 0 && failedLoginDateTime != null;
    const failedLoginTime = hasFailedLogins ? dayjs(new Date(failedLoginDateTime)).format(DATEFORMATS.TSN) : '';
    const failedLoginMessage = hasFailedLogins
        ? `There ${failedLoginCount === 1 ? 'was' : 'were'} ${failedLoginCount} failed login ${failedLoginCount === 1 ? 'attempt' : 'attempts'} since your last successful login. Last failed attempt: ${failedLoginTime}.`
        : '';

    useEffect(() => {
        // Clear failed login count when the banner is shown to the user
        if (hasFailedLogins) {
            clearFailedLogin();
        }
    }, [hasFailedLogins]);
    return (
    <>
        <div style={{ width: "100%", paddingLeft: 0, paddingRight: 0 }}>
            <Divider variant="middle" textAlign="center"></Divider>
        </div>
        {showPasswordExpiryMessage ?
        (<Typography variant="body1" gutterBottom padding={2}>
            {`Your password will expire ${expiryDays == 0 ? 'today' : 'in ' + expiryDays + ' days'}. Please reset your password before expiration to continue using AMS.`}
        </Typography>) : null}

        {hasFailedLogins ? (
            <Typography variant="body1" gutterBottom padding={2} >{failedLoginMessage}</Typography>
        ) : null}

        {accessControlSettings?.bannerEnabled ? (
            <>
                <Typography variant="body1" gutterBottom padding={2}>{`Last successful Login was ${lastLoginTime}.`}</Typography>
                <Typography variant="body1" gutterBottom padding={2}>{accessControlSettings?.messageOfDay}</Typography>
            </>
        ) : null}

        <div style={{ width: "100%", paddingBottom: "24px" }}>
            <Divider variant="middle" textAlign="center"></Divider>
        </div>        
    </>
  );
};